
/// <reference path="../../_ext/editors/BOMGridEditor.ts" />


namespace TabAurous.Inventory {
    import fld = BranchOutBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class BranchOutBOMEditor extends _Ext.BOMGridEditor<BranchOutBOMRow> { 
        protected getDialogType() { return BranchOutBOMDialog; }
        protected getLocalTextPrefix() { return BranchOutBOMRow.localTextPrefix; } 
    }
}